import { Card, CardContent, Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../../../apis/dreamrichapi';
import { ChangeRiskManagement } from '../../../../redux/actions/customerActions';
import { SelectCurrentPage } from '../../../../redux/actions/planningActions';
import { IStore } from '../../../../redux/types/store';
import { lineSpacing } from '../../../../theme/spacingBetweenComponents';
import LoadingPage from '../../../global/loadingPage/desktop/loadingPage';
import { IFinancialInfo } from '../../../toolbarInfo/types';
import { ICustomerPageProps } from '../../types';
import Corrections from '../corrections/corrections';
import EmergencySavings from '../emergencySavings/emergencySavings';
import Insurances from '../insurances/insurances';
import InventoryFreeAssets from '../inventoryFreeAssets/inventoryFreeAssets';
import LifeQuality from '../lifeQuality/lifeQuality';
import ProtectionNeeded from '../protectionNeeded/protectionNeeded';
import SuccessionCost from '../successionCost/successionCost';
import SuggestionCardPension from '../suggestionCardPension/suggestionCardPension';
import { IRiskManagement } from '../types';
import formatter from '../../../global/formater';
import { useStyles } from './style'

const RiskManagement: React.FC<ICustomerPageProps> = ({ userID, pageNumber }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [, setErr] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    const { rentability, riskManagement, successionWithdraw, personalData, pension } = useSelector((store: IStore) => ({
        rentability: store.customer.rentability,
        riskManagement: store.customer.riskManagement,
        successionWithdraw: store.customer.successionWithdraw,
        personalData: store.planning.customerFormValues.customerInfo.personalInfo.personalInfo,
        pension: store.planning.customerFormValues.patrimony.pensions,
    }));

    const userIDCompare: string = String(localStorage.getItem("userID"));
    const personalDataStorage = JSON.parse(localStorage.getItem("storageCustomer" + userID))?.customerInfo?.personalInfo;
    const riskStorage = JSON.parse(localStorage.getItem("riskManagement" + userIDCompare));

    React.useEffect(() => {
        dispatch(SelectCurrentPage(pageNumber));
    }, []);

    React.useEffect(() => {

        const loadLocalStorage = async () => {

            if (localStorage.getItem("riskManagement" + userIDCompare) != undefined || localStorage.getItem("riskManagement" + userIDCompare) != null) {

                dispatch(ChangeRiskManagement(JSON.parse(String(localStorage.getItem("riskManagement" + userIDCompare)))));
                setLoading(false);

                let rentabilityValue = rentability;

                if (!rentability) {
                    rentabilityValue = await getDefaultRentability();
                }

                let url = `/riskmanagement?rentability=${rentabilityValue}`;
                if (userID) {
                    url += `&userID=${userID}`;
                }
                if (successionWithdraw) {
                    url += `&quality=${successionWithdraw}`;
                } else {
                    //setLoading(true);
                }

                const response = (await api.get<IRiskManagement>(url)).data;

                if (String(localStorage.getItem("riskManagement" + userIDCompare)) !== JSON.stringify(response)) {
                    localStorage.setItem("riskManagement" + userIDCompare, JSON.stringify(response));
                    dispatch(ChangeRiskManagement(response));
                }

            } else {
                let rentabilityValue = rentability;

                if (!rentability) {
                    rentabilityValue = await getDefaultRentability();
                }

                let url = `/riskmanagement?rentability=${rentabilityValue}`;
                if (userID) {
                    url += `&userID=${userID}`;
                }
                if (successionWithdraw) {
                    url += `&quality=${successionWithdraw}`;
                } else {
                    setLoading(true);
                }

                const response = (await api.get<IRiskManagement>(url)).data;
                localStorage.setItem("riskManagement" + userIDCompare, JSON.stringify(response));
                dispatch(ChangeRiskManagement(response));
            }
            setLoading(false);
        };

        const getDefaultRentability = async () => {
            try {
                const response = await api.get<IFinancialInfo>('/financialinfo');
                return response.data.profileGain.default;
            } catch (e) {
                console.error(e);
                return 0;
            }
        };

        loadLocalStorage();

    }, [successionWithdraw, dispatch, rentability, setLoading]);

    const diff = {
        current: riskManagement.protectionNeeded.current.lifeQuality,
        future: riskManagement.protectionNeeded.future.lifeQuality,
    };

    const rendaAnualBruta = personalDataStorage?.annualGrossIncome || personalData?.annualGrossIncome;
    let limiteRendaDeduzida = Number(rendaAnualBruta) * 0.12;
    let aporteLimiteMes = limiteRendaDeduzida / 12;

    let somaSobrasAnuais = 0;

    [...Array(riskManagement.table.planningDuration)].map((_, i) => (
        i < 10
            ? somaSobrasAnuais += riskManagement.table.contributionProjection[i]
            : null
    ))

    let mediaSobrasAnuais = (somaSobrasAnuais / 10);
    let valorSugeridoAno = (mediaSobrasAnuais * 0.35);
    let valorSugeridoMes = (valorSugeridoAno / 12);


    //let valorAnualPGBL = 0;
    let aporteMensalPGBL = 0;

    //let valorAnualVGBL = 0;
    let aporteMensalVGBL = 0;

    for (let i = 0; i < pension.length; i++) {
        if (pension[i].type === 'pgbl') {
            //valorAnualPGBL += pension[i].balance;
            aporteMensalPGBL += pension[i].monthlyContribution
        } else {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            null;
        }
        if (pension[i].type === 'vgbl') {
            //valorAnualVGBL += pension[i].balance;
            aporteMensalVGBL += pension[i].monthlyContribution
        } else {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            null;
        }
    }

    let rate = 0.04;
    let nper = riskManagement.table.planningDuration;
    let valorAuxpmt = 0;

    if (valorSugeridoAno > 0) {
        if (aporteMensalPGBL < aporteLimiteMes) {
            if (valorSugeridoMes <= (aporteLimiteMes - aporteMensalPGBL)) {
                valorAuxpmt = valorSugeridoMes + aporteMensalPGBL;
            } else {
                valorAuxpmt = ((aporteLimiteMes - aporteMensalPGBL) + aporteMensalPGBL);
            }
        } else {
            valorAuxpmt = 0;
        }
    } else {
        valorAuxpmt = 0;
    }

    let pmt = ((-0.275 * valorAuxpmt) * 12);
    let pv = 0;

    function valorAteIF(rate: number, nper: number, pmt: number, pv: number) {

        let fv_value = 0;

        if (nper === 0) {
            return (0);
        }
        if (rate === 0) { // Interest rate is 0
            fv_value = -(pv + (pmt * nper));
        } else {
            let x = Math.pow(1 + rate, nper);
            fv_value = - (-pmt + x * pmt + rate * x * pv) / rate;
        }

        return fv_value;
    }

    let valorAteIndependenciaFinanceira = valorAteIF(rate, nper, pmt, pv);

    const loadEmergencySavings = () => {
        if(!riskStorage) return <EmergencySavings {...riskManagement.emergencySavings} />
        else return <EmergencySavings {...riskStorage?.emergencySavings} />
    }

    const loadSuccessionCost = () => {
        if(!riskStorage) return <SuccessionCost {...riskManagement.successionCosts} />
        else return <SuccessionCost {...riskStorage?.successionCosts} />
    }

    const loadInventoryFreeAssets = () => {
        if(!riskStorage) return <InventoryFreeAssets {...riskManagement.inventoryFreeAssets} />
        else return <InventoryFreeAssets {...riskStorage?.inventoryFreeAssets} />
    }

    const loadCorrections = () => {
        if(!riskStorage) return <Corrections {...riskManagement.corrections} />
        else return <Corrections {...riskStorage?.corrections} />
    }

    const loadInventoryInsurances = () => {
        if(!riskStorage) return <Insurances {...riskManagement.contracted} />
        else return <Insurances {...riskStorage?.contracted} />
    }

    const pgblCalc = () => {

        return valorSugeridoAno > 0
        ? Number(rendaAnualBruta) <= 0
            ? aporteMensalPGBL > 0
                ? formatter.format(0)
                : 'Informe uma renda bruta anual'
            : aporteMensalPGBL < aporteLimiteMes
                ? valorSugeridoMes <= (aporteLimiteMes - aporteMensalPGBL)
                    ? formatter.format(valorSugeridoMes)
                    : formatter.format(aporteLimiteMes - aporteMensalPGBL)
                : formatter.format(valorSugeridoMes)
        : Number(rendaAnualBruta) <= 0
            ? 'Informe uma renda bruta anual'
            : 'Sem sugestão'
    }

    return (
        <LoadingPage loading={loading}>
            <div className={classes.root}>
                <Typography className={classes.subHeading} variant="h5">
                    Previdência já contratada
                </Typography>
                <div className='mb-5 w-50'>
                    <div className={classes.cardLine}>
                        <div style={{ marginRight: '15px' }}>
                            <SuggestionCardPension
                                className={classes.cardItem}
                                header="Renda anual tributável"
                                value={
                                    formatter.format(Number(rendaAnualBruta))
                                }
                                disabled={false}
                                typographyClassName={
                                    classes.secondaryTextColor
                                }
                                onClick={() => { }}
                            />
                        </div>
                    </div>
                </div>
                <Typography variant="h5" style={{ marginTop: '12px' }} >
                    Sugestões de Previdência
                </Typography>
                <div className='mb-5' style={{ marginTop: '15px', width: '65%' }}>
                    <div className={classes.cardLine}>
                        <div style={{ marginRight: '15px' }}>
                            <SuggestionCardPension
                                className={classes.cardItem}
                                header="PGBL"
                                value={pgblCalc()?.toString()}
                                disabled={false}
                                typographyClassName={
                                    valorSugeridoAno > 0
                                        ? Number(rendaAnualBruta) > 0
                                            ? classes.secondaryTextColor
                                            : classes.secondaryTextColor
                                        : classes.errorTextColor
                                }
                                onClick={() => { }}
                            />
                        </div>
                        {valorAteIndependenciaFinanceira === 0
                            ? <Card
                                elevation={3}
                                style={{ flexGrow: 1, backgroundColor: '#023C58', height: '100%' }}
                            >
                                <CardContent>
                                    <Typography className={classes.cardHeader}>
                                        Expectativa de patrimônio na IF com o reinvestimento das restituições do PGBL
                                    </Typography>
                                    <div className={classes.content}>
                                        <Typography
                                            style={{ fontSize: 18, minWidth: 100 }}
                                            className={classes.cardValueNegative}
                                        >
                                            Sem PGBL contratada
                                        </Typography>
                                    </div>
                                </CardContent>
                            </Card>
                            : <Card
                                elevation={3}
                                style={{ flexGrow: 1, backgroundColor: '#023C58', height: '100%' }}
                            >
                                <CardContent>
                                    <Typography className={classes.cardHeader}>
                                        Expectativa de patrimônio na IF com o reinvestimento das restituições do PGBL
                                    </Typography>
                                    <div className={classes.content}>
                                        <Typography
                                            style={{ fontSize: 18, minWidth: 100 }}
                                            className={classes.cardValuePositive}
                                        >
                                            {formatter.format(valorAteIndependenciaFinanceira)}
                                        </Typography>
                                    </div>
                                </CardContent>
                            </Card>
                        }
                    </div>
                </div>
            </div>

            {loadEmergencySavings()}
            {lineSpacing()}
            <LifeQuality
                diff={diff.current}
                {...riskManagement.lifeQuality}
                projection={riskManagement.projection}
            />
            {lineSpacing()}
            {loadSuccessionCost()}
            {lineSpacing()}
            {loadInventoryFreeAssets()}
            {lineSpacing()}
            <ProtectionNeeded
                diff={diff}
                freeAssets={riskManagement.inventoryFreeAssets}
                {...riskManagement.protectionNeeded}
                totalInvested={riskManagement.lifeQuality.totalInvested}
            />
            {lineSpacing()}
            {loadCorrections()}
            {lineSpacing()}
            {loadInventoryInsurances()}
            {lineSpacing()}

        </LoadingPage >
    );
};
export default RiskManagement;
